import "../../../../content/departments/brands/brands.css";
import * as React from 'react';
export default {
  React
};